<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75" />
  <path d="M12 11V16" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <circle cx="12" cy="8" r="0.75" fill="currentColor" />
</svg>
